import { Row } from "@tanstack/react-table";
import { useState } from "react";
import CheckboxField from "../../../checkboxField/checkboxField";
import { CheckboxFieldProps } from "../../../checkboxField/types/checkboxFieldProps";

const CheckboxCell = (row: Row<any>, checkboxesTable: Row<any>[], setCheckboxes: (props: Row<any>[]) => void, rowCompare?: ((row1: Row<any>, row2: Row<any>) => boolean)) => {
    const compare = (row1: Row<any>, row2: Row<any>) => {
        if (rowCompare !== undefined) {
            return rowCompare(row1, row2);
        }
        return false;
    }

    const [checkedCell, setCheckedCell] = useState(row !== undefined ? checkboxesTable.some(ct => compare(ct, row)) : false);

    const onChangeCheckBoxColumnCell = () => {
        var checkedRows: Row<any>[] = [...checkboxesTable];
        if (row !== undefined && row !== null) {
            var _isChecked = checkboxesTable.some(ct => compare(ct, row));
            if (_isChecked) {
                var filteredObjects = checkedRows.filter((Row) => {
                    return !compare(Row, row);
                });
                setCheckboxes(filteredObjects);
            }
            else {
                checkedRows.push(row);
                setCheckboxes(checkedRows);
            }
            setCheckedCell(checkboxesTable.some(ct => compare(ct, row)));
        }
    };

    const CheckboxFieldPropsCell: CheckboxFieldProps = {
        onChange: onChangeCheckBoxColumnCell,
        inputChecked: checkedCell,
        checkmarkStylization: {
            width: '16px',
            height: '16px',
            verticalAlign: 'middle'
        },
        style: {
            width: '100%',
            textAlign: 'center'
        },
        checkmarkSmall: true
    }

    return (<CheckboxField {...CheckboxFieldPropsCell}></CheckboxField>)
}

export default CheckboxCell;